module.exports = __webpack_public_path__ + "img/icon_vertrag.02e4ddfd.svg";